export default {
  methods: {
    // We need this function to set necessary variables in menuItem array
    // and delete unnecessary variables wich changing by menuItem.type
    changeMenuType(index) {
      if (this.form.menu.menuItems[index].type === 1) {
        delete this.form.menu.menuItems[index].link;
        delete this.form.menu.menuItems[index].category;
        this.form.menu.menuItems[index].page = "";
      } else if (this.form.menu.menuItems[index].type === 2) {
        delete this.form.menu.menuItems[index].page;
        delete this.form.menu.menuItems[index].category;
        this.form.menu.menuItems[index].link = "";
      } else if (this.form.menu.menuItems[index].type === 3) {
        delete this.form.menu.menuItems[index].page;
        delete this.form.menu.menuItems[index].link;
        this.form.menu.menuItems[index].category = "";
      }
    },
  },
};
